import { render, staticRenderFns } from "./prevBtn.vue?vue&type=template&id=e02a75b0&scoped=true"
import script from "./prevBtn.vue?vue&type=script&lang=js"
export * from "./prevBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e02a75b0",
  null
  
)

export default component.exports